export const IMPERSONATION_FAILED_CODE = "IMPERSONATION_FAILED";

export type ImpersonationFailure = {
  code: typeof IMPERSONATION_FAILED_CODE;
  reason: string;
  message: string;
  retryable: boolean;
};

type GraphQLErrorLike = {
  message?: unknown;
  extensions?: unknown;
};

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null;

export function getImpersonationFailure(graphQLErrors: unknown): ImpersonationFailure | null {
  if (!Array.isArray(graphQLErrors)) return null;

  const graphQLError = graphQLErrors.find((error): error is GraphQLErrorLike => {
    if (!isRecord(error)) return false;
    if (error.extensions === undefined || !isRecord(error.extensions)) return false;

    return error.extensions.code === IMPERSONATION_FAILED_CODE;
  });

  if (!graphQLError || !isRecord(graphQLError.extensions)) return null;

  return {
    code: IMPERSONATION_FAILED_CODE,
    reason: typeof graphQLError.extensions.reason === "string" ? graphQLError.extensions.reason : "UNKNOWN",
    message:
      typeof graphQLError.message === "string"
        ? graphQLError.message
        : "The assumed-user request could not be completed.",
    retryable: graphQLError.extensions.retryable === true
  };
}

export function getImpersonationFailureFromError(error: unknown): ImpersonationFailure | null {
  if (!isRecord(error) || !Array.isArray(error.graphQLErrors)) return null;

  return getImpersonationFailure(error.graphQLErrors);
}

export function isUnauthorizedNetworkError(error: unknown): boolean {
  if (typeof error !== "object" || error === null) return false;

  return (error as { statusCode?: unknown }).statusCode === 401;
}
